import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-leave-balance',
  templateUrl: './leave-balance.component.html'
})
export class LeaveBalanceComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/modules/leave/components/leave-balance-details/leave-balance.component.ts